import * as FIELD_NAME from './fieldNames';

export const RECOVERY_OF_LIQUID = {
  None: 'None',
  Air: 'Air',
  Buffer: 'Buffer',
  Air_Buffer: 'Air_Buffer',
};

export const RECOVERY_OF_LIQUID_ID = {
  None: 1,
  Air: 2,
  Buffer: 3,
  Air_Buffer: 4,
};

export const LEFT_CONICAL = {
  FIFTY: '50',
};

export const MORE_THAN_50_ML = {
  OFF: 'false',
  ON: 'true',
};

export const TOTAL_VALVE_IN_CHIP = {
  Five: '5',
  Six: '6',
};

export const SKIP_PRIMING = {
  ON: 'true',
  OFF: 'false',
};

export const SKIP_PRIMING_ID = {
  ON: 2,
  OFF: 1,
};

export const UPDATE_TYPE = {
  SOFTWARE: 'SOFTWARE',
  FIRMWARE: 'FIRMWARE',
  OPERATING_SYSTEM: 'OPERATING_SYSTEM',
};
export const UPDATE_STATUS = {
  IDLE: 'IDLE',
  UPDATING: 'UPDATING',
  COMPLETE: 'COMPLETE',
  FAILED: 'FAILED',
};

export const MANUAL_CONTROL = {
  DEFAULT_VOLUME_MANUAL_CONTROL: 'DEFAULT\nVOLUME',
  CUSTOM_VOLUME_MANUAL_CONTROL: 'CUSTOM\nVOLUME',
  HOLD_TO_RUN: 'HOLD TO RUN',
};

export const MANUAL_CONTROL_STATE = {
  ENABLE: 'true',
  DISABLE: 'false',
};
// backend ENUM
export const DEVICE_ELEMENT_CHECK = {
  CHIP_SENSOR: 'CHIP_SENSOR',
  BOTTLE_WASTE_SENSOR: 'BOTTLE_WASTE_SENSOR',
  DRAINAGE_WASTE_SENSOR: 'DRAINAGE_WASTE_SENSOR',
};

export const UI_VIEW_TYPE = {
  REMOTE: 'REMOTE',
  DEVICE: 'DEVICE',
};

export const SOFTWARE_UPDATE_ERROR = {
  NONE: 'NONE',
  NO_INTERNET: 'NO_INTERNET',
  OUTDATED: 'OUTDATED',
  SAME_VERSION: 'SAME_VERSION',
  CORRUPTED: 'CORRUPTED',
  LICENSE_EXPIRED: 'LICENSE_EXPIRED',
  DOWNLOAD_TIMEOUT: 'DOWNLOAD_TIMEOUT',
  INVALID_TIME: 'INVALID_TIME',
};

export const WIFI_ERROR = {
  NONE: 'None',
  INCORRECT_PASSWORD: 'IncorrectPassword',
  CONNECTION_TIMED_OUT: 'ConnectionTimedOut',
  EMPTY_PASSWORD: 'EmptyPassword',
  INCORRECT_SSID_AND_PASSWORD: 'IncorrectSsidAndPassword',
};

/**
 * @enum {String} Alert Message Type
 */
export const ALERT_TYPE = {
  ALERT_SUCCESS: 'alert-success',
  ALERT_INFO: 'alert-info',
  ALERT_DANGER: 'alert-danger',
  ALERT_WARNING: 'alert-warning',
};
export const REMOTE_SUPPORT = {
  SESSION_STATE: {
    InProgress: 'InProgress',
    Success: 'Success',
    Fail: 'Fail',
    None: 'None',
  },
  DEVICE_STATUS: {
    Manage: 'Manage',
    UnManage: 'UnManage',
  },
};

export const PRESSURE = {
  0: 'source',
  1: 'vacuum',
  2: 'diaphragm',
  3: 'returnValve',
};

export const PRESSURE_ROW = {
  SOURCE: 0,
  VACUUM: 1,
  DIAPHRAGM: 2,
  BOTTLE: 3,
};

export const FIELD_NAME_PRESSURE = {
  [PRESSURE_ROW.SOURCE]: FIELD_NAME.SOURCE_PRESSURE,
  [PRESSURE_ROW.VACUUM]: FIELD_NAME.VACUUM_PRESSURE,
  [PRESSURE_ROW.DIAPHRAGM]: FIELD_NAME.DIAPHRAGM_PRESSURE,
  [PRESSURE_ROW.BOTTLE]: FIELD_NAME.BOTTLE_PRESSURE,
};

/**
 * @enum {String}
 */
export const HISTORY_SHOW_TYPE = {
  ALL: 'ALL',
  DATE: 'DATE',
};

/**
 * @enum {String}
 */
export const HISTORY_SHOW_TYPE_DATE_OPTION = {
  SEARCH_FILTER: 'SEARCH_FILTER',
  SEARCH_FILTER_BEGIN: 'SEARCH_FILTER_BEGIN',
  SEARCH_FILTER_END: 'SEARCH_FILTER_END',
  NEWER: 'NEWER',
  OLDER: 'OLDER',
  NEWEST: 'NEWEST',
  OLDEST: 'OLDEST',
  SORT: 'SORT',
  SORT_ASCENDING: 'SORT ASCENDING',
  SORT_DESCENDING: 'SORT DESCENDING',
  SORT_TO_OLDEST: 'SORT TO OLDEST',
  SORT_TO_NEWEST: 'SORT TO NEWEST',
  SORT_TO_50ML: '50ML',
  SORT_TO_15ML: '15ML',
};

/**
 * @enum {String}
 */
export const HISTORY_SHOW_TYPE_DATE_RANGE = {
  SEARCH_FILTER_BEGIN: 'SEARCH_FILTER_BEGIN',
  SEARCH_FILTER_END: 'SEARCH_FILTER_END',
};

/**
 * @enum {String}
 */
export const HISTORY_SHOW_DATE = {
  START: 'START',
  END: 'END',
};

/**
 * @enum {String}
 */
export const CYCLE_LOG_PROFILE_MODE = {
  ALL: 'ALL',
  AUTO_PROFILE: 'Auto Profile',
  MANUAL_PROFILE: 'Manual Profile',
};
/**
 * @enum {String}
 */
export const CURRENT_RUNNING_MODE = {
  AUTO_PROFILE: 'AUTO_PROFILE',
  MANUAL_PROFILE: 'MANUAL_PROFILE',
  CLEANING_WIZARD: 'CLEANING_WIZARD',
};

/**
 * @see AutoProfileOperationWorker class on Back-End project
 * @enum {Number}
 */
export const PROGRESS_BAR_COMMON_VALUE = {
  PERCENTAGE_MAX_OF_PRIME: 5,
  PERCENTAGE_MAX_OF_CONCENTRATE_DIAFILTRATION: 90,
  PERCENTAGE_MAX_OF_RECOVERY: 5,
};

/**
 * @see OperationCompleteStatus enum on Back-End project
 * @enum {String}
 */
export const OPERATION_COMPLETE_STATUS = {
  NONE: 'NONE',
  ERROR: 'ERROR',
  STOPPED: 'STOPPED',
  FINISHED: 'FINISHED',
};

/**
 * @enum {String}
 */
export const PROFILE_MODE = {
  AUTO: 'Auto Profile',
  MANUAL: 'Manual Profile',
};

/**
 * @enum {String}
 */
export const PROFILE_TYPE = {
  NONE: 'NONE',
  CONCENTRATE: 'Concentrate',
  CONCENTRATE_50: 'Concentrate More than 50mL',
  BUFFER_EXCHANGE_DISCRETE: 'Buffer Exchange Discrete',
  BUFFER_EXCHANGE_CONTINUOUS: 'Buffer Exchange Continuous',
};

export const TARE_STAGE_ENUM = {
  Reset: 0,
  Calibration: 1,
  CheckScale: 2,
  StartUp: 3,
  History: 4,
};

export const VOLUME_TYPE = {
  V50ML: '50mL',
  V15ML: '15 mL',
};

export const MANUAL_CONTROL_ENUM = {
  HOLD_TO_RUN: 3,
  CUSTOM_VOLUME_MANUAL_CONTROL: 2,
  DEFAULT_VOLUME_MANUAL_CONTROL: 1,
};

export const SCHEDULE_PROFILE = {
  LICENSE_EXPIRED: 'LICENSE_EXPIRED',
  EDIT_NOT_ALLOWED: 'EDIT_NOT_ALLOWED',
  TIME_HAS_PASSED: 'TIME_HAS_PASSED',
};

export const RECOVERY_PREPARATION_STATE = {
  NONE: 'None',
  PRE_AIR_RECOVERY: 'PreAirRecovery',
  POST_BUFFER_RECOVERY: 'PostBufferRecovery',
};

export const CLEANING_WIZARD_STATE = {
  BUFFER_EXCHANGE: 'BUFFER EXCHANGE',
  AIR_RECOVERY: 'AIR RECOVERY',
};
